import { client } from "../../client";

export interface AccountFinancials {
  lastBill: BillInfo | null;
  payment: AccountPaymentDetails;
  balance: AccountBalance;
}

export const SCHEDULE_TYPES = ["Variable", "Fixed", "Seasonal"] as const;
type ScheduleType = typeof SCHEDULE_TYPES[number];

export const ACCOUNT_PAYMENT_METHODS = [
  "SmartPAYG",
  "Prepay",
  "DirectDebit",
  "Other",
  "Multiple",
] as const;
type AccountPaymentMethod = typeof ACCOUNT_PAYMENT_METHODS[number];

export type AccountBalance = {
  balance: string;
  overdueBalance: string;
  currency: string | null;
};

export type PaymentSchedule = {
  type: ScheduleType;
  amount: string;
  currency: string;
};

export type PaymentPlan = {
  id: string;
  collectType: string;
  createdDttm: string;
  status: string;
};

export type DebtRecoveryInfo = {
  id: string;
  amount: string;
  fromDttm: string;
  toDttm: string;
  createdDttm: string;
  stoppedDttm: string | null;
};

export type AccountPaymentDetails = {
  schedule: PaymentSchedule;
  method: AccountPaymentMethod;
  activePaymentPlans: PaymentPlan[] | null;
  activeDebtRecoveries: DebtRecoveryInfo[] | null;
};

export interface BillInfo {
  number: string;
  grossAmount: string;
  netAmount: string;
  currency: string;
  dueDt: string | null;
  issueDt: string;
}

export const getAccountFinancials = (
  queryKey: string,
  accountNumber: string,
) => {
  return client
    .get<AccountFinancials>(`accounts/${accountNumber}/financials`)
    .then((response) => response?.data);
};
